module.exports = __webpack_public_path__ + "static/media/wed_pano_01.550865ec.jpg";